import { Badge } from "@repo/ui/components/ui/badge";
import type { ReactNode } from "react";

export type StatusTone = "idle" | "open" | "done" | "attention" | "error";

const TONES: Record<StatusTone, string> = {
  idle: "bg-muted-foreground/10 text-muted-foreground",
  open: "bg-blue-500/10 text-blue-700 dark:bg-blue-500/20 dark:text-blue-300",
  done: "bg-emerald-500/10 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300",
  attention: "bg-amber-500/10 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300",
  error: "bg-destructive/10 text-destructive dark:bg-destructive/20",
};

export function StatusBadge({ tone, children }: { tone: StatusTone; children: ReactNode }) {
  return (
    <Badge variant="outline" className={`border-transparent font-normal normal-case ${TONES[tone]}`}>
      {children}
    </Badge>
  );
}
